const type = '[GANTT]';

export const SET_LANES_INFO = `${type} SET_LANES_INFO`;
export const SET_LANE_INFO = `${type} SET_LANE_INFO`;
export const SET_LANE_INFO_IS_DRAGGING_OVER = `${type} SET_LANE_INFO_IS_DRAGGING_OVER`;

export const SET_LANES_DATA = `${type} SET_LANES_DATA`;
export const SET_LANE_DATA = `${type} SET_LANE_DATA`;

export const ADD_LANE_DATA = `${type} ADD_LANE_DATA`;
export const DELETE_LANE_DATA = `${type} DELETE_LANE_DATA`;

export const SET_GANTT_DIMENSIONS = `${type} SET_GANTT_DIMENSIONS`;
export const SET_VIEW_DIMENSIONS = `${type} SET_VIEW_DIMENSIONS`;
export const SET_VIEW = `${type} SET_VIEW`;
export const SET_VIEW_INTERNAL = `${type} SET_VIEW_INTERNAL`;
export const SET_DATE_REFERENCE = `${type} SET_DATE_REFERENCE`;
export const SET_VIEW_WORKING_DAYS = `${type} SET_VIEW_WORKING_DAYS`;

export const FETCH_BOARD_DATA = `${type} FETCH_BOARD_DATA`;
export const FETCH_BOARD_DATA_SUCCESS = `${type} FETCH_BOARD_DATA_SUCCESS`;
export const FETCH_BOARD_DATA_FAILURE = `${type} FETCH_BOARD_DATA_FAILURE`;
export const RESET_BOARD_DATA = `${type} RESET_BOARD_DATA`;

export const FETCH_VIEW_DATA = `${type} FETCH_VIEW_DATA`;
export const FETCH_VIEW_DATA_SUCCESS = `${type} FETCH_VIEW_DATA_SUCCESS`;
export const FETCH_VIEW_DATA_FAILURE = `${type} FETCH_VIEW_DATA_FAILURE`;

export const UPDATE_BLOCK_DATA = `${type} UPDATE_BLOCK_DATA`;
export const UPDATE_BLOCK_DATA_SUCCESS = `${type} UPDATE_BLOCK_DATA_SUCCESS`;
export const UPDATE_BLOCK_OTHER_LANE_DATA_SUCCESS = `${type} UPDATE_BLOCK_OTHER_LANE_DATA_SUCCESS`;
export const UPDATE_BLOCK_DATA_FAILURE = `${type} UPDATE_BLOCK_DATA_FAILURE`;

export const FETCH_BLOCK_DATA = `${type} FETCH_BLOCK_DATA`;
export const FETCH_BLOCK_DATA_SUCCESS = `${type} FETCH_BLOCK_DATA_SUCCESS`;
export const FETCH_BLOCK_DATA_FAILURE = `${type} FETCH_BLOCK_DATA_FAILURE`;

export const FETCH_FORWARD_BLOCKS_DATA = `${type} FETCH_FORWARD_BLOCKS_DATA`;
export const FETCH_FORWARD_BLOCK_DATA = `${type} FETCH_FORWARD_BLOCK_DATA`;
export const FETCH_FORWARD_BLOCK_DATA_SUCCESS = `${type} FETCH_FORWARD_BLOCK_DATA_SUCCESS`;
export const FETCH_FORWARD_BLOCK_DATA_FAILURE = `${type} FETCH_FORWARD_BLOCK_DATA_FAILURE`;

export const PUBLISH_TO_SAP = `${type} PUBLISH_TO_SAP`;
export const PUBLISH_TO_SAP_SUCCESS = `${type} PUBLISH_TO_SAP_SUCCESS`;
export const PUBLISH_TO_SAP_FAILURE = `${type} PUBLISH_TO_SAP_FAILURE`;

export const PUBLISH_ALL_TO_SAP = `${type} PUBLISH_ALL_TO_SAP`;
export const PUBLISH_ALL_TO_SAP_SUCCESS = `${type} PUBLISH_ALL_TO_SAP_SUCCESS`;
export const PUBLISH_ALL_TO_SAP_FAILURE = `${type} PUBLISH_ALL_TO_SAP_FAILURE`;

export const MARK_DATE_CONFIRMED = `${type} MARK_DATE_CONFIRMED`;
export const MARK_DATE_CONFIRMED_SUCCESS = `${type} MARK_DATE_CONFIRMED_SUCCESS`;
export const MARK_DATE_CONFIRMED_FAILURE = `${type} MARK_DATE_CONFIRMED_FAILURE`;

export const MARK_DATE_UNCONFIRMED = `${type} MARK_DATE_UNCONFIRMED`;
export const MARK_DATE_UNCONFIRMED_SUCCESS = `${type} MARK_DATE_UNCONFIRMED_SUCCESS`;
export const MARK_DATE_UNCONFIRMED_FAILURE = `${type} MARK_DATE_UNCONFIRMED_FAILURE`;

export const RESTORE_BACKUP = `${type} RESTORE_BACKUP`;
export const RESTORE_BACKUP_SUCCESS = `${type} RESTORE_BACKUP_SUCCESS`;
export const RESTORE_BACKUP_FAILURE = `${type} RESTORE_BACKUP_FAILURE`;

export const SPLIT_BLOCK = `${type} SPLIT_BLOCK`;
export const SPLIT_BLOCK_SUCCESS = `${type} SPLIT_BLOCK_SUCCESS`;
export const SPLIT_BLOCK_FAILURE = `${type} SPLIT_BLOCK_FAILURE`;

export const ADD_BLOCK_DATA = `${type} ADD_BLOCK_DATA`;
export const ADD_BLOCK_DATA_SUCCESS = `${type} ADD_BLOCK_DATA_SUCCESS`;
export const ADD_BLOCK_DATA_FAILURE = `${type} ADD_BLOCK_DATA_FAILURE`;

export const ADD_MULTI_BLOCK_DATA = `${type} ADD_MULTI_BLOCK_DATA`;
export const ADD_MULTI_BLOCK_DATA_SUCCESS = `${type} ADD_MULTI_BLOCK_DATA_SUCCESS`;
export const ADD_MULTI_BLOCK_DATA_FAILURE = `${type} ADD_MULTI_BLOCK_DATA_FAILURE`;

export const UPDATE_MULTI_PLANNING_BLOCK_DATA = `${type} UPDATE_MULTI_PLANNING_BLOCK_DATA`;
export const UPDATE_MULTI_PLANNING_BLOCK_DATA_SUCCESS =
  `${type} UPDATE_MULTI_PLANNING_BLOCK_DATA_SUCCESS`;
export const UPDATE_MULTI_PLANNING_BLOCK_DATA_FAILURE =
  `${type} UPDATE_MULTI_PLANNING_BLOCK_DATA_FAILURE`;

export const DELETE_BLOCK = `${type} DELETE_BLOCK`;
export const DELETE_BLOCK_SUCCESS = `${type} DELETE_BLOCK_SUCCESS`;
export const DELETE_BLOCK_FAILURE = `${type} DELETE_BLOCK_FAILURE`;
export const DELETE_PREVIEW = `${type} DELETE_PREVIEW`;

export const UPDATE_GANTT_FILTERS = `${type} UPDATE_GANTT_FILTERS`;

export const SET_CURRENT_PAGE = `${type} SET_CURRENT_PAGE`;

export const SET_IS_DRAGGING_OVER = `${type} SET_IS_DRAGGING_OVER`;

export const UPDATE_BLOCK_ID = `${type} UPDATE_BLOCK_ID`;

export const UPDATE_BLOCK_OPERATION_INFO = `${type} UPDATE_BLOCK_OPERATION_INFO`;

export const SET_LOADING_ARRAY = `${type} SET_LOADING_ARRAY`;

export const OPEN_PLANNING_AND_VIEW = `${type} OPEN_PLANNING_AND_VIEW`;
export const OPEN_PLANNING_AND_VIEW_SUCCESS = `${type} OPEN_PLANNING_AND_VIEW_SUCCESS`;
export const OPEN_PLANNING_AND_VIEW_FAILURE = `${type} OPEN_PLANNING_AND_VIEW_FAILURE`;
export const RESET_OPEN_PLANNING_AND_VIEW = `${type} RESET_OPEN_PLANNING_AND_VIEW`;

export const FETCH_PUBLISH_ALL_COUNT = `${type} FETCH_PUBLISH_ALL_COUNT`;
export const FETCH_PUBLISH_ALL_COUNT_SUCCESS = `${type} FETCH_PUBLISH_ALL_COUNT_SUCCESS`;
export const FETCH_PUBLISH_ALL_COUNT_FAILURE = `${type} FETCH_PUBLISH_ALL_COUNT_FAILURE`;

export const GET_GANTT_VIEWS_REQUEST = `${type} GET_GANTT_VIEWS_REQUEST`;
export const GET_GANTT_VIEWS_SUCCESS = `${type} GET_GANTT_VIEWS_SUCCESS`;
export const GET_GANTT_VIEWS_FAILURE = `${type} GET_GANTT_VIEWS_FAILURE`;

export const CREATE_GANTT_VIEW_REQUEST = `${type} CREATE_GANTT_VIEW_REQUEST`;
export const CREATE_GANTT_VIEW_SUCCESS = `${type} CREATE_GANTT_VIEW_SUCCESS`;
export const CREATE_GANTT_VIEW_FAILURE = `${type} CREATE_GANTT_VIEW_FAILURE`;

export const UPDATE_GANTT_VIEWS_REQUEST = `${type} UPDATE_GANTT_VIEWS_REQUEST`;
export const UPDATE_GANTT_VIEWS_SUCCESS = `${type} UPDATE_GANTT_VIEWS_SUCCESS`;
export const UPDATE_GANTT_VIEWS_FAILURE = `${type} UPDATE_GANTT_VIEWS_FAILURE`;

export const UPDATE_GANTT_SORT = `${type} UPDATE_GANTT_SORT`;
export const UPDATE_GANTT_VIEW = `${type} UPDATE_GANTT_VIEW`;

export const SET_BLOCK_PREVIEW = `${type} SET_BLOCK_PREVIEW`;
export const SET_BLOCK_PREVIEW_FAILURE = `${type} SET_BLOCK_PREVIEW_FAILURE`;

export const RESET_BLOCK_DATA = `${type} RESET_BLOCK_DATA`;

export const SET_ADJACENT_BLOCK = `${type} SET_ADJACENT_BLOCK`;
export const CLEAR_LANES_DATA = `${type} CLEAR_LANES_DATA`;

export const FETCH_BOARD_METADATA = `${type} FETCH_BOARD_METADATA`;
export const FETCH_BOARD_METADATA_SUCCESS = `${type} FETCH_BOARD_METADATA_SUCCESS`;
export const FETCH_BOARD_METADATA_FAILURE = `${type} FETCH_BOARD_METADATA_FAILURE`;

export const SHOULD_FETCH_LANE_DATA = `${type} SHOULD_FETCH_LANE_DATA`;

export const SHOULD_FORCE_FETCH_GANTT_DATA = `${type} SHOULD_FORCE_FETCH_GANTT_DATA`;

export const REFETCH_LANE_DATA_FOR = `${type} REFETCH_LANE_DATA_FOR`;

export const SET_ALL_TECHNICIANS = `${type} SET_ALL_TECHNICIANS`;
export const SET_LANES_INFO_LOCALLY = `${type} SET_LANES_INFO_LOCALLY`;

export const RECALCULATE_TRAVEL_TIME = `${type} RECALCULATE_TRAVEL_TIME`;
export const RECALCULATE_TRAVEL_TIME_SUCCESS = `${type} RECALCULATE_TRAVEL_TIME_SUCCESS`;
export const RECALCULATE_TRAVEL_TIME_FAILURE = `${type} RECALCULATE_TRAVEL_TIME_FAILURE`;

export const FETCH_RECOMMENDED_ENGINEERS = `${type} FETCH_RECOMMENDED_ENGINEERS`;
export const FETCH_RECOMMENDED_ENGINEERS_SUCCESS = `${type} FETCH_RECOMMENDED_ENGINEERS_SUCCESS`;
export const FETCH_RECOMMENDED_ENGINEERS_FAILURE = `${type} FETCH_RECOMMENDED_ENGINEERS_FAILURE`;

export const CALCULATE_ROUTE_OPTIMISATION = `${type} CALCULATE_ROUTE_OPTIMISATION`;
export const CALCULATE_ROUTE_OPTIMISATION_SUCCESS = `${type} CALCULATE_ROUTE_OPTIMISATION_SUCCESS`;
export const CALCULATE_ROUTE_OPTIMISATION_FAILURE = `${type} CALCULATE_ROUTE_OPTIMISATION_FAILURE`;

export const ABORT_ROUTE_OPTIMISATION = `${type} ABORT_ROUTE_OPTIMISATION`;
export const ABORT_ROUTE_OPTIMISATION_SUCCESS = `${type} ABORT_ROUTE_OPTIMISATION_SUCCESS`;
export const ABORT_ROUTE_OPTIMISATION_FAILURE = `${type} ABORT_ROUTE_OPTIMISATION_FAILURE`;

export const RETRY_ROUTE_OPTIMISATION = `${type} RETRY_ROUTE_OPTIMISATION`;
export const RETRY_ROUTE_OPTIMISATION_SUCCESS = `${type} RETRY_ROUTE_OPTIMISATION_SUCCESS`;
export const RETRY_ROUTE_OPTIMISATION_FAILURE = `${type} RETRY_ROUTE_OPTIMISATION_FAILURE`;

export const FORWARD_PLANNING_UPDATED = `${type} FORWARD_PLANNING_UPDATED`;
export const FORWARD_PLANNING_PLANNED = `${type} FORWARD_PLANNING_PLANNED`;

export const RESET_GANTT_LANE_TO_FETCH = `${type} RESET_GANTT_LANE_TO_FETCH`;

export const FETCH_PLANNING_DATA_POST_SOCKET_UPDATE =
  `${type} FETCH_PLANNING_DATA_POST_SOCKET_UPDATE`;
export const FETCH_PLANNING_DATA_POST_SOCKET_UPDATE_SUCCESS =
  `${type} FETCH_PLANNING_DATA_POST_SOCKET_UPDATE_SUCCESS`;
export const FETCH_PLANNING_DATA_POST_SOCKET_UPDATE_FAILURE =
  `${type} FETCH_PLANNING_DATA_POST_SOCKET_UPDATE_FAILURE`;

export const DELETE_PLANNING_DATA_POST_SOCKET =
  `${type} DELETE_PLANNING_DATA_POST_SOCKET`;

export const RESET_SOCKET_STATE = `${type} RESET_SOCKET_STATE`;

export const UPDATE_DATA_FROM_SOCKETS = `${type} UPDATE_DATA_FROM_SOCKETS`;
